module.exports = __webpack_public_path__ + "img/JgIndex6.a0cab203.png";